import I from 'immutable';
import Flux from 'lib/flux';
import ContactConstants from 'constants/contact';

const ContactStore = Flux.createStore({
  name: 'contact',

  getInitialState() {
    return {
      sending: false,
      sendingCompleted: false,
      sendingErrors: {},
    };
  },

  actions: [
    [
      ContactConstants.SEND_MESSAGE,
      function (contents) {
        this.state = this.state.merge({
          sending: true,
          sendingCompleted: false,
          sendingErrors: {},
        });
      },
    ],

    [
      ContactConstants.SEND_MESSAGE_COMPLETED,
      function () {
        this.state = this.state.merge({
          sending: false,
          sendingCompleted: true,
          sendingErrors: {},
        });
      },
    ],

    [
      ContactConstants.SEND_MESSAGE_FAILED,
      function (payload) {
        this.state = this.state.merge({
          sending: false,
          sendingErrors: payload.errors,
        });
      },
    ],
  ],
});

export default ContactStore;
